<template>
  <div class="about">
    <h1>A site for events for a better world</h1>
  </div>
</template>
